module.exports = "https://web-assets.ifttt.com/packs/media/icons-v2/check-1bb57431.svg";